<div class="wrap">
  <div class="wrap__container">
    <article class="container">
      <div class="container__header">
        <h2 class="title">STUDIO BUKI株式会社</h2>
      </div>
      <div class="container__content">
        <div class="content">
          <div class="content__item">
            <p class="text">東京都渋谷区千駄ヶ谷3-15-3</p>
          </div>
          <div class="content__item">
            <p class="text">
              <a
                href="tel:05053722976"
                target="_blank"
              >050-5372-2976</a>（代表）
            </p>
          </div>
          <div class="content__item">
            <p class="text">2019年5月創業</p>
          </div>
          <div class="content__item">
            <p class="text">
              <a
                href="mailto:yay@hellobuki.com"
                target="_blank"
              >yay@hellobuki.com</a>
            </p>
          </div>
        </div>
      </div>
      <div class="container__character"></div>
    </article>
  </div>
</div>
